<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="acknowledgment"><a id="page_viii"></a><a id="page_ix"></a>Acknowledgments</h2>
<p class="indent">I would like to thank several people who helped me with this book. They include Sara Zapolsky and Shereen Remez of AARP; Robert Berenson and Eugene Steuerle of the Urban Institute; Michael Koetting and my son, Trevor Goldsmith, both of the University of Chicago; Dawn Malone and Bonnie Schelor of Bon Secours Health System in Richmond, Virginia; John Bertko of Humana Corporation; Jay Olshansky of the University of Illinois; Jane Boon Pearlstine of New York City; and Stan Amy of New Villages Group in Portland, Oregon. My editor, Wendy Harris, at the Johns Hopkins University Press provided gentle and substantive guidance in revising my manuscript. Anita Gupta, Kelly Cush, and Susan Sleight, all of Charlottesville, provided invaluable research assistance.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgment.vue?223dcaee